import React from 'react'
import { Trans, useLingui } from '@lingui/react/macro'

import { Card } from '@newComponents/Card'
import { Paragraph } from '@newComponents/Text'
import { Link } from '@newComponents/Link'

import { DocSection } from '../shared/DocSection'
import { DocScreenshot } from '../shared/DocScreenshot'

const Joining = () => {
  const { t } = useLingui()

  return (
    <>
      <Card gap='$4'>
        <Paragraph size='$5'>
          <Trans>
            Anyone can join a <Link href='/docs/guilds/overview'>Guild</Link> by
            visiting the Guild&apos;s profile page and clicking the{' '}
            <Paragraph size='$5' fontWeight='$7'>
              Join
            </Paragraph>{' '}
            button. Organizers can share a direct link to their Guild page to
            make it easy for people to find and join.
          </Trans>
        </Paragraph>
        <DocScreenshot
          src='docs/guilds/guilds-listing.png'
          alt='All Guilds listing page showing Guild cards with profile photos, names, and Join buttons'
          caption={t`Browse the Guilds listing to discover communities and join with a single click`}
        />
      </Card>

      <Card gap='$4'>
        <DocSection id='membership-forms' title={t`Membership Forms`}>
          <Paragraph size='$5'>
            <Trans>
              If a Guild has a membership form enabled, new Members must fill it
              out before joining. Forms let Organizers collect information such
              as name, email, interests, or anything else relevant to the
              community. See the{' '}
              <Link href='/docs/guilds/members'>Managing Members</Link> section
              for details on form field types.
            </Trans>
          </Paragraph>
        </DocSection>
      </Card>

      <Card gap='$4'>
        <DocSection
          id='approval-process'
          title={t`Guilds That Require Approval`}
        >
          <Paragraph size='$5'>
            <Trans>
              For Guilds that require approval, new Members enter a{' '}
              <Paragraph size='$5' fontWeight='$7'>
                pending
              </Paragraph>{' '}
              state after submitting the form. They remain pending until an
              Organizer reviews their application and approves or denies it.
              Approved Members appear on the Guild&apos;s Members tab and can
              start attending <Link href='/docs/events/overview'>Events</Link>{' '}
              right away.
            </Trans>
          </Paragraph>
        </DocSection>
      </Card>
    </>
  )
}

export default Joining
